import React from 'react';
import PropTypes from 'prop-types';
import useAppContext from 'flow/hooks/useAppContext';
import { openCallWidgetLink } from 'flow/actions/run-url-actions';
import Icon from 'flow/components/ui-components/Icon';

const CallExternalSearchWidget = ({ name, url }) => {
    const { i18next } = useAppContext();

    return (
        <div
            className="flex cursor-pointer flex-row content-between items-center overflow-hidden rounded-xs bg-gray-800 text-ellipsis whitespace-nowrap"
            onClick={() => openCallWidgetLink(url)}
        >
            <div className="flex content-start items-center text-xs font-light text-gray-400">
                <div className="flex min-w-9 content-center items-center text-gray-200">
                    <Icon iconKey={'search'} className="size-4 py-2" />
                </div>
                <div className="overflow-hidden text-ellipsis">{name}</div>
            </div>
            <div className="flex content-end items-center px-2 text-xs font-light text-gray-800">
                <div className="flex items-center">
                    {i18next.t('call.search_for_number')}
                </div>
            </div>
        </div>
    );
};

CallExternalSearchWidget.propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export default CallExternalSearchWidget;
